import { render, staticRenderFns } from "./QuestTabs.vue?vue&type=template&id=15ae3d8e&scoped=true"
import script from "./QuestTabs.vue?vue&type=script&lang=js"
export * from "./QuestTabs.vue?vue&type=script&lang=js"
import style0 from "./QuestTabs.vue?vue&type=style&index=0&id=15ae3d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae3d8e",
  null
  
)

export default component.exports